/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.security.state.rpc.SecurityStateAppRpc
 */

export const getContentSecurityStateRpc = {
  serviceName: 'com.hubspot.security.state.rpc.SecurityStateAppRpc',
  rpcName: 'getContentSecurityState',
  auth: 'app',
  fingerprint: 'nmAXWKdpkI6h0OflzTRgOfmZqtIXlJv-',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};